import fetch from "auth/FetchInterceptor";
import { ApiConstant } from "constants/ApiConstant";
import Utils from "utils";

const StudentService = {};

StudentService.getStudentList = function (params) {
  return fetch({
    url: ApiConstant.GET_STUDENT_LIST,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
StudentService.downalodStudentExcel = function (data, params) {
  const ids = Array.isArray(data) ? data : [data];
  return fetch({
    url: ApiConstant.STUDENT_EXCEL_DOWNLAOD,
    method: "PATCH",
    params: Utils.filterHeaderParams(params),
    data: { ids },
  });
};
StudentService.statusUpdateStudent = function (data) {
  const payload = {
    id: data.params.id,
    status: data.data.status,
  };
  return fetch({
    url: ApiConstant.STUDENT_STATUS_UPDATE,
    method: "patch",
    data: payload,
  });
};

StudentService.addStudent = function (data, params) {
  return fetch({
    url: ApiConstant.ADD_STUDENT,
    method: "post",
    data: data,
    params: Utils.filterHeaderParams(params),
  });
};
StudentService.getSingleStudent = function (params) {
  return fetch({
    url: `${ApiConstant.GET_SINGLE_STUDENT}`,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};

StudentService.updateStudent = function (data, params) {
  return fetch({
    url: `${ApiConstant.EDIT_STUDENT}`,
    method: "patch",
    data: data,
    params: Utils.filterHeaderParams(params),
  });
};
StudentService.updateBulkStuentsStatus = function (data, status) {
  const payload = {
    status: status,
    ids: Array.isArray(data) ? data : [data],
  };
  return fetch({
    url: ApiConstant.STUDENT_BULK_STATUS_UPDATE,
    method: "patch",
    data: payload,
  });
};
StudentService.studentBulkDelete = function (data, status) {
  console.log(data, status);

  const payload = {
    academic_year_id: data?.academic_year_id,
    student_ids: Array.isArray(data?.student_ids)
      ? data?.student_ids
      : [data?.student_ids],
  };
  return fetch({
    url: ApiConstant.STUDENT_BULK_DELETE,
    method: "post",
    data: payload,
  });
};
StudentService.downloadExcelFormat = function (
  academic_id,
  school_id,
  class_id,
  division_id,
  students_count
) {
  return fetch({
    url: `${ApiConstant.DOWNLOAD_EXCEL_FORMAT}?academic_id=${academic_id}&school_id=${school_id}&class_id=${class_id}&division_id=${division_id}&students_count=${students_count}`,
    method: "get",
    responseType: "blob",
    headers: {
      "x-no-transform": true,
    },
  });
};
StudentService.studentBulkCreate = function (
  academic_id,
  school_id,
  class_id,
  division_id,
  data
) {
  return fetch({
    url: `${ApiConstant.STUDENT_BULK_TEMP}?academic_id=${academic_id}&school_id=${school_id}&class_id=${class_id}&division_id=${division_id}`,
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
StudentService.getTempExcelData = function (temp_table_name, params) {
  return fetch({
    url: `${ApiConstant.STUDENT_BULK_TEMP}/${temp_table_name}`,
    method: "get",
    params,
  });
};
StudentService.getStudentsBySchool = function (params) {
  return fetch({
    url: ApiConstant.GET_STUDENTS_BY_SCHOOL,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
StudentService.finalizeTableData = function (temp_table_name) {
  return fetch({
    url: `${ApiConstant.STUDENT_BULK_CREATE}${temp_table_name}`,
    method: "post",
  });
};
StudentService.deleteTempTableData = function (temp_table_name) {
  return fetch({
    url: `${ApiConstant.STUDENT_BULK_TEMP_DELETE}${temp_table_name}`,
    method: "delete",
  });
};

export default StudentService;
